import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractCrudService } from 'src/app/shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './crud-config';
import { API_PATH } from 'src/environments/environment';

@Injectable()
export class CustomerToUpdatePlansService extends AbstractCrudService {
  override title: string = 'Cliente';
  override pluralTitle = 'Clientes';

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  apply(ids: any) {
    return this.httpClient.post(
      `${API_PATH}${this.relativeUrl}/apply`,
      ids
    );
  }
}
